/* __next_internal_client_entry_do_not_use__ Default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Global
import { useRef, useState } from 'react';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import '@splidejs/splide/css';
import { withStandardComponentWrapper } from 'helpers/HOC';
import LinkWrapper from 'helpers/SitecoreWrappers/LinkWrapper/LinkWrapper';
import PlainTextWrapper from 'helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';
import { getTestProps } from 'lib/testing/utils';
import { useIsTablet } from 'lib/hooks/useIsTablet';
import { tv } from 'tailwind-variants';
import ImageWrapper from 'helpers/SitecoreWrappers/ImageWrapper/ImageWrapper';
import RichTextWrapper from 'helpers/SitecoreWrappers/RichTextWrapper/RichTextWrapper';
import { SvgIcon } from 'helpers/SvgIcon';
import { useIsMobile } from 'lib/hooks/useIsMobile';
import { BrandAndThemeProvider } from 'lib/context/BrandAndThemeContext';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
import useIsEditing from 'lib/hooks/useIsEditing';
const LatestNews = (props)=>{
    const isEditing = useIsEditing();
    const { newsCards, cardsCTAText, link } = props?.fields || {};
    const theme = props?.params?.selectTheme;
    const isTablet = useIsTablet();
    const isMobile = useIsMobile();
    const splideRef = useRef(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [totalSlides, setTotalSlides] = useState(0);
    const { base, containerCarousel, containerContent, linkContainer, mainNews, sideNews, eyebrowTextContainer, titleTextContainer, descriptionTextContainer, divider, ctaContainer, card, cardContent, cardCarousel, cardCarouselContent, mainNewsImageStyle, sideNewsItem, sideNewsImageStyle, sideNewsItemContent, sideNewsItemTitle, carouselCardImage, customPaginationDotsWrapper, paginationDots, dotStyle } = TAILWIND_VARIANTS();
    return /*#__PURE__*/ _jsx("section", {
        "data-component": "authorable/shared/content/latestnews",
        ...editingHydrationProps(isEditing),
        ...getTestProps(`component-overlay-card-${props?.rendering?.uid}`),
        children: /*#__PURE__*/ _jsx(BrandAndThemeProvider, {
            theme: theme,
            children: /*#__PURE__*/ _jsxs("div", {
                className: base(),
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        children: isTablet ? newsCards && newsCards.length > 0 && /*#__PURE__*/ _jsxs("div", {
                            className: containerCarousel(),
                            children: [
                                /*#__PURE__*/ _jsx(Splide, {
                                    ref: (ref)=>{
                                        if (ref?.splide) {
                                            splideRef.current = ref.splide;
                                        }
                                    },
                                    hasTrack: false,
                                    onMounted: (splide)=>setTotalSlides(splide.length),
                                    onMove: (_splide, newIndex)=>setCurrentIndex(newIndex),
                                    onMoved: (splide)=>setTotalSlides(splide.length),
                                    options: {
                                        arrows: false,
                                        gap: 'var(--layout-base-gutter)',
                                        pagination: false,
                                        perMove: 1,
                                        perPage: 1,
                                        padding: {
                                            right: isMobile ? 'var(--general-spacing-margin-x)' : '265px'
                                        },
                                        rewind: true,
                                        speed: 500,
                                        type: 'loop',
                                        width: '100%',
                                        drag: true
                                    },
                                    children: /*#__PURE__*/ _jsx(SplideTrack, {
                                        children: newsCards.slice(0, 4).map((newsCard, index)=>/*#__PURE__*/ _jsx(SplideSlide, {
                                                tabIndex: index !== currentIndex ? -1 : 0,
                                                "aria-hidden": index !== currentIndex,
                                                className: "p-2",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: `${card()} ${cardCarousel()}`,
                                                    children: [
                                                        newsCard?.fields?.image && /*#__PURE__*/ _jsx(ImageWrapper, {
                                                            field: newsCard?.fields?.image,
                                                            className: carouselCardImage()
                                                        }),
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: `${cardContent()} ${cardCarouselContent()}`,
                                                            children: [
                                                                newsCard?.fields?.type?.fields?.displayName && /*#__PURE__*/ _jsx("div", {
                                                                    className: eyebrowTextContainer(),
                                                                    children: /*#__PURE__*/ _jsx(PlainTextWrapper, {
                                                                        field: newsCard?.fields?.type?.fields?.displayName,
                                                                        tag: "span"
                                                                    })
                                                                }),
                                                                newsCard?.fields?.pageTitle?.value?.trim() && /*#__PURE__*/ _jsx("div", {
                                                                    className: titleTextContainer(),
                                                                    children: /*#__PURE__*/ _jsx(PlainTextWrapper, {
                                                                        field: newsCard?.fields?.pageTitle,
                                                                        tag: "h2"
                                                                    })
                                                                }),
                                                                newsCard?.fields?.shortDescription && /*#__PURE__*/ _jsx("div", {
                                                                    className: descriptionTextContainer(),
                                                                    children: /*#__PURE__*/ _jsx(RichTextWrapper, {
                                                                        field: newsCard?.fields?.shortDescription
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: divider()
                                                                }),
                                                                newsCard?.url && /*#__PURE__*/ _jsx("div", {
                                                                    className: ctaContainer(),
                                                                    children: /*#__PURE__*/ _jsx(LinkWrapper, {
                                                                        ctaComponentClass: "default",
                                                                        className: "w-auto",
                                                                        ctaVariant: "secondary",
                                                                        ctaIcon: "arrow-right",
                                                                        ctaIconSize: "s",
                                                                        field: {
                                                                            value: {
                                                                                href: newsCard?.url,
                                                                                text: cardsCTAText?.value,
                                                                                linktype: 'internal'
                                                                            }
                                                                        },
                                                                        "aria-label": newsCard?.fields?.pageTitle?.value?.trim() ? `${cardsCTAText?.value || 'Read more'} for ${newsCard.fields.pageTitle.value}` : undefined,
                                                                        suppressNewTabIcon: true
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }, newsCard?.id))
                                    })
                                }),
                                /*#__PURE__*/ _jsx("nav", {
                                    role: "navigation",
                                    "aria-label": "Carousel Pagination",
                                    children: /*#__PURE__*/ _jsx("ul", {
                                        className: customPaginationDotsWrapper(),
                                        children: Array.from({
                                            length: totalSlides
                                        }).map((_, i)=>/*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx("button", {
                                                    onClick: ()=>splideRef.current?.go(i),
                                                    className: paginationDots({
                                                        isActiveSlide: i === currentIndex
                                                    }),
                                                    "aria-label": `Go to slide ${i + 1}`,
                                                    children: /*#__PURE__*/ _jsx(SvgIcon, {
                                                        icon: i === currentIndex ? 'carousel-active-pagedot' : 'carousel-pagedot',
                                                        size: i === currentIndex ? 'm' : 'xxs',
                                                        viewBox: i === currentIndex ? '0 0 40 12' : '0 0 12 12',
                                                        className: dotStyle({
                                                            isActiveSlide: i === currentIndex
                                                        })
                                                    })
                                                })
                                            }, i))
                                    })
                                })
                            ]
                        }) : newsCards && newsCards.length > 0 && /*#__PURE__*/ _jsxs("div", {
                            className: containerContent(),
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: `${mainNews()} ${card()}`,
                                    children: [
                                        newsCards[0]?.fields?.image && /*#__PURE__*/ _jsx(ImageWrapper, {
                                            field: newsCards[0].fields.image,
                                            className: mainNewsImageStyle()
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: cardContent(),
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: eyebrowTextContainer(),
                                                    children: /*#__PURE__*/ _jsx(PlainTextWrapper, {
                                                        field: newsCards[0]?.fields?.type?.fields?.displayName,
                                                        tag: "span"
                                                    })
                                                }),
                                                newsCards[0]?.fields?.pageTitle?.value?.trim() && /*#__PURE__*/ _jsx("div", {
                                                    className: titleTextContainer(),
                                                    children: /*#__PURE__*/ _jsx(PlainTextWrapper, {
                                                        field: newsCards[0].fields.pageTitle,
                                                        tag: "h2"
                                                    })
                                                }),
                                                newsCards[0]?.fields?.shortDescription && /*#__PURE__*/ _jsx("div", {
                                                    className: descriptionTextContainer(),
                                                    children: /*#__PURE__*/ _jsx(RichTextWrapper, {
                                                        field: newsCards[0].fields.shortDescription
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: divider()
                                                }),
                                                newsCards[0]?.url && /*#__PURE__*/ _jsx("div", {
                                                    className: ctaContainer(),
                                                    children: /*#__PURE__*/ _jsx(LinkWrapper, {
                                                        ctaComponentClass: "default",
                                                        className: "w-auto",
                                                        ctaVariant: "secondary",
                                                        ctaIcon: "arrow-right",
                                                        ctaIconSize: "s",
                                                        field: {
                                                            value: {
                                                                href: newsCards[0].url,
                                                                text: cardsCTAText?.value,
                                                                linktype: 'internal'
                                                            }
                                                        },
                                                        "aria-label": newsCards[0]?.fields?.pageTitle?.value?.trim() ? `${cardsCTAText?.value || 'Read more'} for ${newsCards[0].fields.pageTitle.value}` : undefined,
                                                        suppressNewTabIcon: true
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                newsCards.length > 1 && /*#__PURE__*/ _jsx("div", {
                                    className: sideNews(),
                                    children: newsCards.slice(1, 4).map((newsCard)=>/*#__PURE__*/ _jsxs("div", {
                                            className: `${sideNewsItem()} ${card()}`,
                                            children: [
                                                newsCard?.fields?.image && /*#__PURE__*/ _jsx(ImageWrapper, {
                                                    field: newsCard?.fields?.image,
                                                    className: sideNewsImageStyle()
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: sideNewsItemContent(),
                                                    children: [
                                                        newsCard?.fields?.pageTitle?.value?.trim() && /*#__PURE__*/ _jsx(PlainTextWrapper, {
                                                            field: newsCard?.fields?.pageTitle,
                                                            tag: "h2",
                                                            className: sideNewsItemTitle()
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: divider()
                                                        }),
                                                        newsCard?.url && /*#__PURE__*/ _jsx("div", {
                                                            className: ctaContainer(),
                                                            children: /*#__PURE__*/ _jsx(LinkWrapper, {
                                                                ctaComponentClass: "default",
                                                                className: "w-auto",
                                                                ctaVariant: "secondary",
                                                                ctaIcon: "arrow-right",
                                                                ctaIconSize: "s",
                                                                field: {
                                                                    value: {
                                                                        href: newsCard?.url,
                                                                        text: cardsCTAText?.value,
                                                                        linktype: 'internal'
                                                                    }
                                                                },
                                                                "aria-label": newsCard?.fields?.pageTitle?.value?.trim() ? `${cardsCTAText?.value || 'Read more for '} ${newsCard.fields.pageTitle.value}` : `${cardsCTAText?.value || 'Read more'}`,
                                                                suppressNewTabIcon: true
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, newsCard?.id))
                                })
                            ]
                        })
                    }),
                    link && /*#__PURE__*/ _jsx("div", {
                        className: linkContainer(),
                        children: /*#__PURE__*/ _jsx(LinkWrapper, {
                            ctaComponentClass: "default",
                            ctaVariant: "primary",
                            ctaIcon: "arrow-right",
                            ctaIconSize: "s",
                            field: link,
                            suppressNewTabIcon: true
                        })
                    })
                ]
            })
        })
    });
};
export const Default = withStandardComponentWrapper(LatestNews);
const TAILWIND_VARIANTS = tv({
    slots: {
        base: [
            'py-component-section-container-padding-y',
            'relative'
        ],
        mainNews: [
            'flex-1'
        ],
        sideNews: [
            'flex-1',
            'flex',
            'flex-col',
            'gap-spacing-spacing-24'
        ],
        cardContent: [
            'px-component-card-item-portrait-content-padding-x',
            'pt-component-card-item-portrait-content-padding-top',
            'pb-component-card-item-portrait-content-padding-bottom'
        ],
        cardCarouselContent: [
            'flex',
            'flex-col',
            'flex-1'
        ],
        containerCarousel: [
            // Break out of parent container padding on tablet/mobile for full-bleed carousel
            '-mr-general-spacing-margin-x'
        ],
        containerContent: [
            'flex',
            'gap-layout-base-gutter'
        ],
        card: [
            'bg-component-card-item-surface',
            'border-component-card-item-border-width',
            'border-component-card-item-border',
            '[box-shadow:0_0_8px_0_var(--color-black-alpha-10,rgba(0,0,0,0.10))]',
            'rounded-general-border-radius-card'
        ],
        cardCarousel: [
            'flex',
            'flex-col',
            'h-full'
        ],
        linkContainer: [
            'mt-component-section-container-gutter',
            'flex',
            'justify-center',
            '[&_a]:w-auto'
        ],
        eyebrowTextContainer: [
            'text-component-card-item-eyebrow',
            'font-typography-font-family-body',
            'text-typography-font-size-body-xSmall',
            'leading-[150%]',
            'font-semibold',
            'uppercase'
        ],
        titleTextContainer: [
            'mt-spacing-spacing-4',
            'text-component-card-item-title',
            'font-typography-font-family-header',
            'text-typography-font-size-medium',
            'leading-typography-line-height-medium',
            'font-normal'
        ],
        descriptionTextContainer: [
            'mt-spacing-spacing-24',
            'text-component-card-item-body',
            'font-typography-font-family-body',
            'text-typography-font-size-body-medium',
            'leading-typography-line-height-body-medium',
            'font-normal'
        ],
        divider: [
            'mt-component-video-card-portrait-content-button-margin-top',
            'w-[100px]',
            'h-[2px]',
            'bg-color-core-color-3-Coral'
        ],
        ctaContainer: [
            'mt-spacing-spacing-24',
            'flex',
            '[&_a]:w-auto'
        ],
        mainNewsImageStyle: [
            'w-full',
            'aspect-[628/353.52]'
        ],
        sideNewsItem: [
            'flex'
        ],
        sideNewsImageStyle: [
            'rounded-tl-component-card-item-image-radius',
            'rounded-tr-border-radius-radius-0',
            'rounded-bl-component-card-item-image-radius',
            'rounded-br-border-radius-radius-0',
            'object-cover',
            'w-1/2'
        ],
        sideNewsItemContent: [
            'w-1/2',
            'py-component-card-item-landscape-content-1-col-padding-y',
            'px-component-card-item-landscape-content-1-col-padding-x'
        ],
        sideNewsItemTitle: [
            'text-component-card-item-title',
            'font-typography-font-family-body',
            'text-typography-font-size-body-large',
            'leading-typography-line-height-body-large',
            'font-normal'
        ],
        carouselCardImage: [
            'w-full',
            'aspect-[382/215.04]',
            'md:aspect-[423/238.12]'
        ],
        customPaginationDotsWrapper: [
            'flex',
            'gap-spacing-spacing-12',
            'items-center',
            'justify-center',
            'mt-component-section-container-gutter'
        ],
        paginationDots: [],
        dotStyle: []
    },
    compoundSlots: [
        {
            slots: [
                'mainNewsImageStyle',
                'carouselCardImage'
            ],
            class: [
                'rounded-tl-component-card-item-image-radius',
                'rounded-tr-component-card-item-image-radius',
                'rounded-bl-border-radius-radius-0',
                'rounded-br-border-radius-radius-0'
            ]
        }
    ],
    variants: {
        isActiveSlide: {
            true: {
                paginationDots: [
                    'w-10',
                    'h-6',
                    'flex',
                    'justify-center',
                    'items-center'
                ],
                dotStyle: [
                    '!w-10',
                    'text-color-fill-dark',
                    '[stroke-width:1px]',
                    'stroke-color-border-dark'
                ]
            },
            false: {
                paginationDots: [
                    'w-6',
                    'h-6',
                    'flex',
                    'justify-center',
                    'items-center'
                ],
                dotStyle: [
                    '[stroke-width:1px]',
                    'stroke-color-border-dark',
                    'fill-none'
                ]
            }
        },
        backgroundLayout: {
            FullWidth: {
                base: [
                    'before:z-[-2]',
                    'before:h-full',
                    'before:absolute',
                    'before:bg-component-section-bg',
                    'before:top-0',
                    'before:left-[calc(-50vw+50%)]',
                    'before:right-[calc(-50vw+50%)]'
                ]
            },
            Content: {
                base: [
                    'bg-component-section-bg'
                ]
            }
        }
    },
    defaultVariants: {
        backgroundLayout: 'FullWidth'
    }
});
